module.exports = __webpack_public_path__ + "media/images/iconTrendDown__okGreen-bd2e310f2ce3579de22650098427dd89.png";